import { render, staticRenderFns } from "./ExtraSeatsCard.vue?vue&type=template&id=acbba864&scoped=true"
import script from "./ExtraSeatsCard.vue?vue&type=script&lang=js"
export * from "./ExtraSeatsCard.vue?vue&type=script&lang=js"
import style0 from "./ExtraSeatsCard.vue?vue&type=style&index=0&id=acbba864&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbba864",
  null
  
)

export default component.exports